'use client';

import { useTranslations } from 'next-intl';
import { SettingsCard } from '../../SettingsCard';
import { RequestsPerMinuteSlider } from '../RequestsPerMinuteSlider';

export type RequestRateLimitSettingsCardProps = {
  value: number | null | undefined;
  disabled?: boolean;
  onCommit: (next: number | null) => Promise<boolean>;
};

export function RequestRateLimitSettingsCard({
  value,
  disabled,
  onCommit,
}: RequestRateLimitSettingsCardProps) {
  const t = useTranslations('designSystem.automation.requestRateLimit');

  return (
    <SettingsCard>
      <RequestsPerMinuteSlider
        label={t('label')}
        tooltip={t('tooltip')}
        value={value}
        disabled={disabled}
        onCommit={onCommit}
      />
    </SettingsCard>
  );
}
